import { Tooltip } from '@bryntum/schedulerpro';
import { Moment } from 'moment';
import { useEffect } from 'react';
import { SchedulerReference } from 'components/organisms/resource-management/types';
import { useTranslate } from 'hooks/use-translation';
import { dehumaniseDate } from '../../utils/de-humanise';

export const usePlaceholderTooltip = (
  ref: SchedulerReference,
  relativeDate: Moment,
  isHoursPerWeek: boolean,
): void => {
  const translate = useTranslate();

  useEffect(() => {
    const tooltip = new Tooltip({
      forSelector: '.placeholder',
      getHtml: (params) => {
        const { event } = params;
        const placeholderContent =
          event.target.getAttribute('data-placeholder');

        if (isHoursPerWeek) {
          return placeholderContent !== ''
            ? translate(
                'templates.resource_management.tooltips.placeholder.week',
                {
                  week:
                    dehumaniseDate(
                      placeholderContent.split('-')[1].trim(),
                    ).diff(relativeDate, 'week') + 1,
                },
              )
            : '';
        }

        return placeholderContent !== ''
          ? translate('templates.resource_management.tooltips.placeholder', {
              startDay: dehumaniseDate(placeholderContent).diff(
                relativeDate,
                'days',
              ),
            })
          : '';
      },
      hoverDelay: 0,
      hideDelay: 0,
      constrainTo: ref.current.instance.timeAxisSubGridElement,
    });

    return () => {
      tooltip.destroy();
    };
  }, [ref, relativeDate, translate, isHoursPerWeek]);
};
